import IconExpandLess from "@mui/icons-material/ExpandLess";
import { Box, Button, IconButton } from "@mui/material";

type MapPillHeaderProps = {
    icon: React.ReactNode;
    title: string;
    open: boolean;
    onOpenToggle: () => void;
    hasDot: boolean;
};

export function MapPillHeader({ icon, title, open, onOpenToggle, hasDot }: MapPillHeaderProps) {
    return (
        <Box
            sx={theme => ({
                gridColumn: "1 / -1",

                // we use grid for a smooth transition showing the close icon
                // we dont want the header to jump in width when showing it
                // with this grid workaround we can make sure it scrolls open smoothly
                display: "grid",
                transition: theme.transitions.create("all", {
                    duration: theme.transitions.duration.shorter,
                }),
                gridTemplateColumns: open ? "1fr 40px" : "1fr 0",

                minWidth: "fit-content",
                overflow: "hidden",
                textWrap: "nowrap",
            })}
        >
            <Button
                variant="text"
                onClick={onOpenToggle}
                sx={theme => ({
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.background.paper,
                    textTransform: "none",
                    fontWeight: "bold",

                    gap: 1,
                    paddingInline: 2,
                    paddingBlock: 1,

                    minWidth: "fit-content",
                    justifyContent: "start",

                    transition: theme.transitions.create("all", {
                        duration: theme.transitions.duration.shorter,
                    }),
                    borderRadius: open ? "4px" : "40px",
                    "&:hover": {
                        backgroundColor: open ? "transparent" : theme.palette.background.default,
                    },

                    "&:after": hasDot && {
                        content: '""',
                        display: "block",
                        backgroundColor: theme.palette.primary.main,

                        width: "10px",
                        height: "10px",
                        borderRadius: "100%",

                        transform: open ? "scale(0)" : "scale(1)",
                        transition: theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                        }),
                    },
                })}
            >
                {icon}
                {title}
            </Button>

            <IconButton
                onClick={onOpenToggle}
                sx={theme => ({
                    opacity: open ? 1 : 0,
                    transition: theme.transitions.create("opacity", {
                        duration: theme.transitions.duration.shorter,
                        delay: theme.transitions.duration.shorter,
                    }),
                })}
            >
                <IconExpandLess />
            </IconButton>
        </Box>
    );
}
